<v2-body-header-0-text color="black" class="header-text">
  Phone Verification
</v2-body-header-0-text>

<v2-body-large-text class="description-text">
  For security reasons a verified phone number is required to start ordering.
  You will receive a text message with a 6 digit code.
</v2-body-large-text>

<form (ngSubmit)="onSubmit()">
  <v2-phone-input
    labelText="Phone Number"
    [required]="true"
    [defaultCountry]="(locationStore.currentLocation$ | async)?.countryCode"
    [formControl]="phoneInputControl"
  ></v2-phone-input>
</form>

<v2-row id="footer-buttons">
  <v2-button [outline]="true" color="primary" (click)="bottomSheetRef.close()">
    CANCEL
  </v2-button>
  <v2-button color="primary" (click)="onSubmit()">NEXT</v2-button>
</v2-row>
